"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockIdentifierValid = exports.BlockIdentifierSchema = void 0;
const zod_1 = require("zod");
const WRONG_STRING_LENGTH = "wrong string length";
exports.BlockIdentifierSchema = zod_1.z.union([
    zod_1.z.string().refine(val => /^[0-9a-fA-F]{64}$/.test(val), WRONG_STRING_LENGTH),
    zod_1.z.number(),
]);
const isBlockIdentifierValid = (blockIdentifier, options) => {
    const ctx = exports.BlockIdentifierSchema.safeParse(blockIdentifier);
    const { success } = ctx;
    const hasError = "error" in ctx;
    const { throwOnError = false } = options || {};
    if (!hasError) {
        return { success };
    }
    const { error } = ctx;
    const isInvalidInputType = error === null || error === void 0 ? void 0 : error.issues.some(({ code }) => code === "invalid_union");
    const isInvalidStringLength = error === null || error === void 0 ? void 0 : error.issues.some(({ message }) => message === WRONG_STRING_LENGTH);
    const message = (() => {
        if (isInvalidInputType) {
            return `Invalid "blockIdentifier" type. Expected string or number, but received ${typeof blockIdentifier}.`;
        }
        if (isInvalidStringLength) {
            return "Parameter 'blockIdentifier' does not have the correct format (64-character hexadecimal string).";
        }
        return error === null || error === void 0 ? void 0 : error.issues.map(issue => issue.message).join(", ");
    })();
    if (throwOnError) {
        throw new Error(message);
    }
    return {
        success,
        error,
        message: error === null || error === void 0 ? void 0 : error.issues.map(issue => issue.message).join(", "),
    };
};
exports.isBlockIdentifierValid = isBlockIdentifierValid;
//# sourceMappingURL=blockIdentifier.js.map